// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_STORAGE_TAG_LIST = 'storageTag/SET_STORAGE_TAG_LIST';
export const ADD_STORAGE_TAG_ITEM = 'storageTag/ADD_STORAGE_TAG_ITEM';
export const SET_STORAGE_TAG_ITEM = 'storageTag/SET_STORAGE_TAG_ITEM';
export const UNSET_STORAGE_TAG_ITEM = 'storageTag/UNSET_STORAGE_TAG_ITEM';
export const REMOVE_STORAGE_TAG_ITEM = 'storageTag/REMOVE_STORAGE_TAG_ITEM';
export const UPDATE_STORAGE_TAG_ITEM = 'storageTag/UPDATE_STORAGE_TAG_ITEM';
export const SET_STORAGE_TAG_ITEM_IS_DELETING = 'storageTag/SET_STORAGE_TAG_ITEM_IS_DELETING';
